import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import '../ExamdetailOverView/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';

function EditExamdetailOverView() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [heading, setHeading] = useState("");
    const [selectedTitleId, setSelectedTitleId] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState("");
    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        fetchRoles();
        fetchOverviewById();
    }, [id]);

    const fetchRoles = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getExamPreparationsPaper`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                },
            });
            setRoleList(response.data);
        } catch (err) {
            console.error("Error fetching Exam Preparations:", err);
        }
    };

    const fetchOverviewById = async () => {
        // alert(id)
        try {
            const response = await axios.get(`${API_BASE_URL}/getExamPreparationOverviewById/${id}`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                },
            });

            const data = response.data[0];
            console.log("data of the api ",response)
            setHeading(data.heading || "");
            setSelectedTitleId(data.exam_preparation_paper_id || "");
            setDescription(data.overview_description || "");
            setStatus(data.status || "");
        } catch (error) {
            console.error("Error fetching overview:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("heading", heading);
        formData.append("exam_preparation_paper_id", selectedTitleId);
        formData.append("overview_description", description);
        formData.append("status", status);

        try {
            const response = await fetch(`${API_BASE_URL}/createExamPreparationOverview/${id}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                },
                body: formData,
            });

            const result = await response.text();

            if (response.ok) {
                console.log("Update success:", result);
                navigate("/admin/ExamdetailOverViewList");
            } else {
                console.error("Update failed:", result);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Edit Overview for Exam Detail</h1>
                        </div>
                        <div className="report-body">
                            <div className="user-form">
                                <form onSubmit={handleSubmit} encType="multipart/form-data">

                                    {/* Heading Input */}
                                    <div className="mb-3">
                                        <label className="form-label">Heading</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={heading}
                                            onChange={(e) => setHeading(e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Dropdown */}
                                    <div className="mb-3">
                                        <label className="form-label">Select Paper</label>
                                        <select
                                            className="form-control"
                                            value={selectedTitleId}
                                            onChange={(e) => setSelectedTitleId(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Paper</option>
                                            {roleList.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    <span dangerouslySetInnerHTML={{ __html: item.description }} /> 
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <ReactQuill
                                            theme="snow"
                                            value={description}
                                            onChange={setDescription}
                                            style={{ height: "200px", marginBottom: "50px" }}
                                        />
                                    </div>

                                    {/* Status Dropdown */}
                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    {/* Submit Button */}
                                    <button type="submit" className="btn btn-primary">
                                        UPDATE
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditExamdetailOverView;
